var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCableZones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 12.0938L12.0001 17.0938L10.5001 18.5938C10.1737 18.9309 9.78356 19.1996 9.35231 19.3845C8.92106 19.5693 8.45734 19.6664 7.98817 19.6702C7.519 19.674 7.05376 19.5844 6.61957 19.4066C6.18537 19.2289 5.7909 18.9664 5.45913 18.6347C5.12737 18.3029 4.86495 17.9084 4.68716 17.4742C4.50937 17.04 4.41977 16.5748 4.42358 16.1056C4.42739 15.6365 4.52453 15.1727 4.70934 14.7415C4.89416 14.3102 5.16295 13.9201 5.50006 13.5938L7.00006 12.0938Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.0937L12 7.09369L13.5 5.59369C13.8263 5.25658 14.2165 4.98779 14.6477 4.80297C15.079 4.61816 15.5427 4.52102 16.0119 4.51721C16.4811 4.5134 16.9463 4.603 17.3805 4.78079C17.8147 4.95857 18.2092 5.221 18.5409 5.55276C18.8727 5.88452 19.1351 6.279 19.3129 6.71319C19.4907 7.14739 19.5803 7.61263 19.5765 8.0818C19.5727 8.55097 19.4755 9.01469 19.2907 9.44594C19.1059 9.87719 18.8371 10.2674 18.5 10.5937L17 12.0937Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.0938L5.5 18.5938",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.59375L21 3.09375",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0938L8 13.0938",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.0938L11 16.0938",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableZones);
export default __webpack_public_path__ + "static/media/CableZones.dcddce8df40e9064a2dc2346b55add29.svg";
export { ForwardRef as ReactComponent };